// extracted by mini-css-extract-plugin
export default {"HeaderDiv":"Header_HeaderDiv__-pwVq"};